<template>
	<div class="container-fluid bg-white">

		<form-toolbar></form-toolbar>

		<forms-tab
			:title="'Completed Forms for ' + $store.company.company_name">
		</forms-tab>

	</div>
</template>

<script>

import FormToolbar from "@/pages/forms/FormToolbar";
import FormsTab from "@/components/super_components/FormsTab"

export default {
	name: "FormList",
	components: {
		FormToolbar,
		FormsTab
	}
}
</script>
